import { useEffect, useState } from "react";
import { FileDown } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, BACKEND_URL } from "@/lib/api";
import { mxn, dateShort } from "@/lib/format";

const inp = "w-full rounded-lg border border-input bg-white px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#FF7A00]";

export const Proposals = ({ lead, onDone }) => {
  const [sims, setSims] = useState([]);
  const [code, setCode] = useState("");
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/leads/${lead.id}/simulations`).then(({ data }) => { setSims(data); if (data[0]) setCode(data[0].code); }).catch(() => {}); }, [lead.id]);
  const generate = async () => {
    setBusy(true);
    try {
      let body = { notes, simulation_code: code || null };
      if (!code) {
        const amount = Number(lead.amount) || 0;
        const months = Number(lead.term_months) || 36;
        const isPyme = lead.product === "pyme";
        const { data: result } = isPyme ? await api.post("/simulators/pyme", { amount, months, segment: lead.segment === "pm" ? "PM" : "PFAE", monthly_revenue: Number(lead.monthly_income) || 0 }) : await api.post("/simulators/credit", { amount, months, product: lead.product || "personal" });
        body = { ...body, tab: isPyme ? "pyme" : "credito", inputs: { amount, months, product: lead.product || "personal" }, result };
      }
      const t = localStorage.getItem("fb_token");
      const r = await fetch(`${BACKEND_URL}/api/leads/${lead.id}/proposal`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json", ...(t ? { Authorization: `Bearer ${t}` } : {}) }, body: JSON.stringify(body) });
      if (!r.ok) throw new Error((await r.json()).detail || "Error");
      const b = await r.blob(); const u = URL.createObjectURL(b); const a = document.createElement("a"); a.href = u; a.download = (r.headers.get("Content-Disposition") || "").split('filename="')[1]?.replace('"', "") || "propuesta.pdf"; a.click(); URL.revokeObjectURL(u);
      toast.success("Propuesta generada y agregada al expediente. Usa el botón verde del documento para enviarla por WhatsApp/correo."); onDone?.();
    } catch (e) { toast.error(errMsg(e) || e.message); } finally { setBusy(false); }
  };
  return (
    <section className="card-warm p-5" data-testid="lead-proposals">
      <h3 className="font-display font-bold mb-2">Propuesta PDF Pro</h3>
      <p className="text-xs text-[#575757] mb-3">Convierte una simulación en propuesta con marca FiinBridge; queda en el expediente y el cliente la ve en su portal.</p>
      <select data-testid="proposal-sim" className={inp} value={code} onChange={(e) => setCode(e.target.value)}>
        <option value="">Simulación rápida con los datos del expediente ({mxn(lead.amount)} · {lead.product})</option>
        {sims.map((s) => <option key={s.code} value={s.code}>{s.label} · {dateShort(s.created_at)} · {s.code}</option>)}
      </select>
      <textarea data-testid="proposal-notes" className={`${inp} mt-2 min-h-[56px]`} placeholder="Notas del asesor para el cliente (opcional)" value={notes} onChange={(e) => setNotes(e.target.value)} />
      <button data-testid="proposal-generate" disabled={busy} onClick={generate} className="btn-brand text-sm mt-2 disabled:opacity-60"><FileDown size={15} /> {busy ? "Generando…" : "Generar propuesta PDF"}</button>
    </section>
  );
};
